import { Reducer, useCallback, useReducer } from "react";

interface IFilterPaginate<TFilter extends object> {
    filter?: TFilter;
    page: number;
}
type FilterPaginateReducerType<TFilter extends object> = Reducer<
    IFilterPaginate<TFilter>,
    Partial<IFilterPaginate<TFilter>>
>;

const defaultInicial = {
    filter: undefined,
    page: 1,
};

export default function usePaginationFilter<TFilter extends object>(
    incial?: IFilterPaginate<TFilter>
) {
    const [PageFilter, setPageFilter] = useReducer<
        FilterPaginateReducerType<TFilter>
    >(filterPaginateReducer, incial ?? defaultInicial);

    const setFilter = useCallback(
        (filter: TFilter) => setPageFilter({ filter }),
        []
    );
    const setPage = useCallback((page: number) => setPageFilter({ page }), []);
    const { page, filter } = PageFilter;

    return { PageFilter, setPageFilter, page, filter, setFilter, setPage };
}

function filterPaginateReducer<TFilter extends object>(
    oldState: IFilterPaginate<TFilter>,
    newState: Partial<IFilterPaginate<TFilter>>
) {
    return {
        ...oldState,
        ...newState,
    } as IFilterPaginate<TFilter>;
}
